import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    fontSize: 14,
    marginTop: 0,
    width: '100%',
  },
  caption: {
    position: 'absolute',
    bottom: 12,
    right: 40,
  },
  captionWithCheckIcon: {
    right: 40,
  },
  readOnly: {
    pointerEvents: 'none',
  },
}));
